import { t } from "i18next";

/**
 * useGamesCountMessage
 *
 * A custom React hook that returns a label based on the number of selected games.
 * The label adapts between singular and plural forms depending on the `count`.
 *
 * This is useful for displaying dynamic, localized UI text that reflects selection count,
 * using a provided `games` object containing correct word forms.
 *
 * @param count - The number of selected games (0 or more)
 * @param games - An object that holds the singular and plural forms of the label
 *
 * @returns A string label appropriate for the given count.
 */

function useGamesCountMessage() {
  return (count: number): string => {
    
    const games = t("statisticPage.header.filter.games", {
      returnObjects: true,
    }) as any;

    const label =
      count === 1
        ? games.nominative.singular
        : games.nominative.plural;

    return `${label}`;
  };
}

export default useGamesCountMessage;
